import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Building2, MonitorSmartphone, UserX, XOctagon } from 'lucide-react';
const solutions = [{
  icon: <Building2 size={32} data-id="element-75" />,
  title: 'Grandes compañías nacionales',
  problem: 'Eres un número de póliza. No una persona.'
}, {
  icon: <MonitorSmartphone size={32} data-id="element-76" />,
  title: 'Herramientas de cotización en línea',
  problem: 'Rápido, barato, confuso — y nadie explica lo que compraste.'
}, {
  icon: <UserX size={32} data-id="element-77" />,
  title: 'Agentes de fuera de la ciudad',
  problem: 'No conocen tu vecindario. Tu vida. Tu familia.'
}, {
  icon: <XOctagon size={32} data-id="element-78" />,
  title: 'No hacer nada',
  problem: 'La opción más costosa de todas — cuando llega el desastre.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedSolutions() {
  return <section className="py-14 md:py-20 bg-white" data-id="element-79">
      <div className="container mx-auto px-4" data-id="element-80">
        <div className="max-w-5xl mx-auto" data-id="element-81">
          <div className="text-center mb-10" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-6" data-id="element-83">
              POR QUÉ LAS VIEJAS SOLUCIONES NO FUNCIONAN
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-84">
              Ninguna de estas soluciones resuelve el problema real de proteger
              a tu familia adecuadamente.
            </p>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-85">
            {solutions.map((solution, index) => <motion.div key={index} variants={itemVariants} className="bg-off-white p-8 rounded-xl border border-gray-200 flex flex-col sm:flex-row items-start gap-6 hover:shadow-lg transition-shadow" data-id="element-86">
                <div className="bg-red-50 text-red-500 p-4 rounded-full shrink-0" data-id="element-87">
                  {solution.icon}
                </div>
                <div data-id="element-88">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-89">
                    {solution.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-90">{solution.problem}</p>
                </div>
              </motion.div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8,
          duration: 0.5
        }} className="bg-navy text-white p-8 md:p-10 rounded-2xl text-center shadow-xl" data-id="element-91">
            <p className="text-xl md:text-2xl font-medium leading-relaxed" data-id="element-92">
              Necesitas a alguien que realmente te conozca, entienda tu
              situación, hable tu idioma y construya un plan que realmente
              proteja lo que has trabajado tanto para lograr.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}